import React from 'react';
import PropTypes from 'prop-types';

let startTouches = {
  x: null,
  y: null,
};

class Swipeable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount() {
    if (this.ref && 'ontouchstart' in document.documentElement) {
      this.ref.addEventListener('touchstart', this.handleTouchStart);
    }
  }

  componentWillUnmount() {
    this.ref.removeEventListener('touchstart', this.handleTouchStart);
  }

  handleTouchStart = e => {
    startTouches = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
    };
    this.ref.addEventListener('touchend', this.handleTouchEnd);
  }

  handleTouchEnd = e => {
    if (startTouches.x && startTouches.y) {
      const endTouches = {
        x: e.changedTouches[0].clientX,
        y: e.changedTouches[0].clientY,
      };

      const xDiff = startTouches.x - endTouches.x;
      const yDiff = startTouches.y - endTouches.y;

      const absXDiff = Math.abs(xDiff);
      const absYDiff = Math.abs(yDiff);

      // * gauge whether user (more likely) intended a horizontal or vertical swipe by checking
      // whether their finger moved more in the left/right direction or more in the
      // up/down direction; necessary since virtually all swipes will actually be somewhat diagonal

      if (absXDiff > absYDiff) { // *
        // swipe is more horizontal than vertical
        if (absXDiff > 9) {
          // swipe isn't just a tiny, accidental nudge
          e.preventDefault();
          // only prevent default if we actually swipe, otherwise don't so we can still potentially
          // click a something that Swipeable is wrapped around
          if (xDiff > 0 && this.props.onSwipeLeft) {
            // xDiff is positive for left, negative for right
            this.props.onSwipeLeft();
          } else if (this.props.onSwipeRight) {
            this.props.onSwipeRight();
          }
        }
      }
      /* else if (absYDiff > 9) {
        // swipe is more vertical than horizontal, and it's not just a tiny, accidental nudge
        if (yDiff > 0 && this.props.onSwipeUp) {
          // yDiff is positive for up, negative for down
          this.props.onSwipeUp();
        } else if (this.props.onSwipeDown) {
          this.props.onSwipeDown();
        }
      } */
    }
    this.ref.removeEventListener('touchend', this.handleTouchEnd);
  }

  render() {
    const { children } = this.props;
    return (
      <div
        className={`swipeable ${this.props.className}`.trim()}
        ref={ref => { this.ref = ref; }}
      >
        {children}
      </div>
    );
  }
}

Swipeable.propTypes = {
  onSwipeLeft: PropTypes.func,
  onSwipeRight: PropTypes.func,
  // onSwipeUp: PropTypes.func,
  // onSwipeDown: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

Swipeable.defaultProps = {
  onSwipeLeft: undefined,
  onSwipeRight: undefined,
  // onSwipeUp: undefined,
  // onSwipeDown: undefined,
  children: null,
  className: undefined,
};

export default Swipeable;



// WEBPACK FOOTER //
// ./src/components/Swipeable.js